import type { IconData } from '@stacksjs/iconify-core'

export const angleDoubleLeft: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M16.25 16a1 1 0 0 1-.707-.293l-3-3a1 1 0 0 1 0-1.414l3-3a1 1 0 0 1 1.414 1.414L14.664 12l2.293 2.293A1 1 0 0 1 16.25 16m-5.5 0a1 1 0 0 1-.707-.293l-3-3a1 1 0 0 1 0-1.414l3-3a1 1 0 0 1 1.414 1.414L9.164 12l2.293 2.293A1 1 0 0 1 10.75 16\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default angleDoubleLeft
